import { styled } from '@mui/material/styles'

const CallToActions = styled('div')`
  display: grid;
  gap: 1rem;
  grid-auto-flow: column;
  justify-content: end;
`

export { CallToActions }
